import { TextInput, SelectInput, maxLength, useListContext, RecordContextProvider, useTranslate } from 'react-admin';
import { Box, Typography, Alert } from '@mui/material';
import BulkDrawer from '@/components/global/drawers/BulkDrawer';
import DeviceGroupInput from '@/components/newDevice/DeviceGroupInput.jsx';
import { DateInput } from '@/components/global/inputs/DateInput.jsx';
import { editTransform } from '@/components/newDevice/forms/editTransform.js';
import { DeploymentStatusInput } from '@/components/newDevice/inputs/DeploymentStatusInput.jsx';

export const NewDeviceBulkForm = () => {
    const translate = useTranslate();
    const { data, selectedIds } = useListContext();
    const selectedData = data.filter(record => selectedIds.includes(record.id));
    const contractorIds = selectedData.map(record => record.contractorId);
    const uniqueContractorIds = [...new Set(contractorIds)];
    const uniqueContractorSelected = uniqueContractorIds.length === 1;
    const selectedContractorId = uniqueContractorSelected ? uniqueContractorIds[0] : null;
    const selectedContractorName = selectedContractorId ? selectedData.find(record => record.contractorId === selectedContractorId)?.contractorName : null;
    const contractorRecord = { id: null, contractorId: selectedContractorId, name: selectedContractorName };
    const contractorChoices = [{ id: selectedContractorId, name: selectedContractorName }];

    const confirmSubmit = formValues => !!formValues.deploymentStatus;
    const confirmMessage = translate('resources.device.labels.confirmMessage', { devicesCount: selectedIds.length });

    return (
        <BulkDrawer
            title={translate('common.update')}
            available={uniqueContractorSelected}
            transform={editTransform}
            confirmSubmit={confirmSubmit}
            confirmMessage={confirmMessage}
        >
            <Box className='popup-wrapper border-bottom'>
                <Box className='popup-box'>
                    <RecordContextProvider value={contractorRecord}>
                        {selectedContractorId && (
                            <SelectInput
                                name='contractorId'
                                source='contractorId'
                                choices={contractorChoices}
                                label={translate('common.contractor')}
                                emptyText={translate('common.all')}
                                fullWidth
                                disabled
                            />
                        )}
                        <Alert severity='info' style={{ marginBottom: '20px' }}>
                            <Typography variant='body1'>
                                {translate('resources.device.labels.editNewDeviceDescription', { selectedIdsCount: selectedIds.length })}
                            </Typography>
                        </Alert>
                        <DeviceGroupInput bulk defaultContractorId={selectedContractorId} />
                    </RecordContextProvider>
                    <DeploymentStatusInput bulk />
                    <TextInput
                        key='description'
                        label={translate('common.description')}
                        source='description'
                        fullWidth
                        multiline
                        validate={maxLength(500, translate('common.validation.maxLength', { count: 500 }))}
                        sx={{ '& textarea': { minHeight: '96px' } }}
                    />
                    <DateInput
                        className='date-input'
                        source='warrantyDate'
                        label={translate('resources.device.fields.warrantyDate')}
                        name='warrantyDate'
                        fullWidth={true}
                    />
                </Box>
            </Box>
        </BulkDrawer>
    );
};
